// extracted by mini-css-extract-plugin
export default {"h1":"VendorSaleList_h1__BeBRS","scrollCover":"VendorSaleList_scrollCover__oKjnK","liquid":"VendorSaleList_liquid__+vE4-","saleListCont":"VendorSaleList_saleListCont__tXHx5"};